import { Component } from '@angular/core';

@Component({
  selector: 'app-gdpr',
  imports: [],
  templateUrl: './gdpr.html',
  styleUrl: './gdpr.css',
})
export class Gdpr {
  features = [
    {
      icon: '🇪🇺',
      title: 'EU Data Protection',
      description: 'Comprehensive GDPR compliance for organizations processing EU citizen data regardless of location.'
    },
    {
      icon: '👤',
      title: 'Data Subject Rights',
      description: 'Implement processes for right to access, rectification, erasure, and data portability requests.'
    },
    {
      icon: '📋',
      title: 'Privacy by Design',
      description: 'Build privacy into systems and processes from the ground up with technical and organizational measures.'
    },
    {
      icon: '🔐',
      title: 'Data Protection Impact',
      description: 'Conduct DPIAs for high-risk processing activities and implement appropriate safeguards.'
    },
    {
      icon: '📊',
      title: 'Data Mapping',
      description: 'Complete inventory of personal data flows, processing activities, and retention schedules.'
    },
    {
      icon: '⚠️',
      title: 'Breach Response',
      description: '72-hour breach notification procedures and incident response planning for data breaches.'
    }
  ];

  process = [
    {
      number: 1,
      title: 'Data Audit',
      description: 'Comprehensive mapping of personal data collection, processing, storage, and transfers.'
    },
    {
      number: 2,
      title: 'Gap Assessment',
      description: 'Identify GDPR compliance gaps and develop remediation roadmap with prioritized actions.'
    },
    {
      number: 3,
      title: 'Implementation',
      description: 'Deploy privacy controls, update policies, and implement data subject rights workflows.'
    },
    {
      number: 4,
      title: 'Ongoing Compliance',
      description: 'Establish continuous monitoring, staff training, and compliance documentation maintenance.'
    }
  ];

  caseStudy = {
    title: 'E-Commerce Platform Achieves GDPR Compliance',
    description: 'A U.S.-based e-commerce company expanding to European markets needed full GDPR compliance to avoid penalties and build customer trust.',
    challenge: 'Complex data flows across multiple vendors, legacy systems without privacy controls, and tight market entry timeline',
    solution: 'End-to-end privacy program including data mapping, vendor assessments, consent management, and privacy-by-design implementation',
    industry: 'E-Commerce',
    timeline: '6 Months',
    result: 'Zero Incidents'
  };

  testimonial = {
    quote: 'HoneyKode demystified GDPR for us. They translated complex regulations into actionable steps and helped us build a privacy program that not only ensures compliance but differentiates us in the market. Essential partner for our EU expansion.',
    author: 'Robert Newman',
    role: 'Chief Privacy Officer, GlobalShop Commerce'
  };
}
